import * as Sentry from "@sentry/react";
import { ApiErrorResponse } from "types";

// TODO: this returns the api ErrorId when there is no errorMessage returned
// we should include a fallback message
export function getErrorMessageKey(error: any) {
    let errorText,
        errorObj,
        errorMessageKey = 'PARKD_API_ERROR_FATAL_ERROR';

    errorText = error?.response?.text;

    if (errorText) {
        try {
            errorObj = JSON.parse(errorText);
            const optionalErrorMessageKey = errorObj?.errors[0]?.errorKey;
            if (optionalErrorMessageKey) {
                errorMessageKey = optionalErrorMessageKey;
            } else {
                const optionalFirstErrorInErrorObject = errorObj?.errors[0];
                if (optionalFirstErrorInErrorObject) {
                    errorMessageKey = optionalFirstErrorInErrorObject;
                }
            }
        } catch (e) {
            console.error(e);
        }
    }

    return errorMessageKey;
}

export function getErrorKeyFromApiError(apiError: ApiErrorResponse) {
    const errorKey = apiError?.response?.body?.errorKey ?? apiError?.response?.body?.data?.errorKey;
    if (errorKey) {
        return errorKey;
    }
    Sentry.captureMessage('Failed to extract errorkey from API response', { extra: apiError });
    return 'PARKD_API_ERROR_FATAL_ERROR';
}
